module.exports = __webpack_public_path__ + "static/media/logo_v2.dc21d61e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_v2.png
// module id = 196
// module chunks = 0